export class SearchCommon {
  constructor(
    public direction?: string,
    public sortBy?: string,
    public pageNumber?: number,
    public pageSize?: number,
  ) {}
}
